import React from 'react';
import moment from 'moment';
import useStyles from './styles';
import { formatISO } from 'date-fns';
import { useStore } from 'src/stores';
import { observer } from 'mobx-react-lite';
import { dateToFormat } from 'src/utils/date';
import { DatePicker } from '@livable/saas-react-components';
import { Icon, ExpandedTooltip } from '@livable/saas-react-components';
import { Button, FormControl, InputAdornment, InputLabel, OutlinedInput, Typography } from '@mui/material';
export const Unit = observer(_ref => {
  let id = _ref.id,
    propertyAddress = _ref.propertyAddress,
    idx = _ref.idx;
  const store = useStore();
  const classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.unit
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "Unit: ", store.residenciesMultiActionStore.getResidentById(id).number), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    color: "light"
  }, store.residenciesMultiActionStore.getResidentById(id).name), !!propertyAddress && /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    color: "light"
  }, propertyAddress)), /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, /*#__PURE__*/React.createElement(FormControl, {
    variant: "outlined",
    className: classes.smallField
  }, /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: "unit-current-occupancy"
  }, "Current"), /*#__PURE__*/React.createElement(OutlinedInput, {
    disabled: true,
    label: "Current",
    id: "unit-current-occupancy",
    value: store.residenciesMultiActionStore.getResidentById(id).inlineDate ? dateToFormat(store.residenciesMultiActionStore.getResidentById(id).inlineDate) : null,
    startAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
      position: "start"
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "lock-locked"
    }))
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.datePicker
  }, /*#__PURE__*/React.createElement(DatePicker, {
    label: "New",
    format: "MM/dd/yy",
    onChange: date => {
      store.residenciesMultiActionStore.setNewInlineDateById(id, formatISO(date).split('T')[0]);
    },
    value: store.residenciesMultiActionStore.getResidentById(id)._inlineDate ? moment(store.residenciesMultiActionStore.getResidentById(id)._inlineDate).toDate() : null
  })), /*#__PURE__*/React.createElement(ExpandedTooltip, {
    hideOnMobile: true,
    placement: "top",
    title: 'Copy to all'
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    className: "".concat(classes.copyButton, " ").concat(idx !== 0 ? 'hidden' : ''),
    onClick: () => {
      store.residenciesMultiActionStore.setNewInlineDateByIdToAll(id);
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "document-file-copy"
  })))));
});